export const PRE_LEAD_STATUSES = [
  "found",
  "kept",
  "ready",
  "approved",
  "sent",
  "replied",
  "converted",
  "closed",
] as const;
export type PreLeadStatus = (typeof PRE_LEAD_STATUSES)[number];

export const CLOSED_REASONS = [
  "removed",
  "not_interested",
  "unsubscribed",
  "bounced",
  "no_reply",
  "not_hot",
  "duplicate",
] as const;
export type ClosedReason = (typeof CLOSED_REASONS)[number];

// copied from supabase/functions/postmark/classifyIntent.ts (Deno globals, not importable here)
export const INTENTS = [
  "interested",
  "question",
  "not_now",
  "not_interested",
  "out_of_office",
  "unsubscribe",
] as const;
export type Intent = (typeof INTENTS)[number];

export const POSITIVE_INTENTS = ["interested", "question"] as const;

export type PreLead = {
  id: number;
  created_at: string;
  updated_at: string;
  sales_id: number | null;
  run_id: string | null;
  segment_name: string | null;
  segment: Record<string, unknown> | null;
  source: string | null;
  ref: string | null;
  company_name: string;
  website: string | null;
  domain: string | null;
  country: string | null;
  city: string | null;
  sector: string | null;
  industry: string | null;
  employees: number | null;
  linkedin_url: string | null;
  fit: number | null;
  criteria: { name: string; score: number }[] | null;
  why: string | null;
  why_now: string | null;
  checked: boolean;
  evidence: Record<string, unknown> | null;
  contact_first_name: string | null;
  contact_last_name: string | null;
  contact_title: string | null;
  contact_email: string | null;
  contact_linkedin_url: string | null;
  sender: "personal" | "sales" | null;
  mailbox: string | null;
  signed_by: string | null;
  candidates: unknown[] | null;
  status: PreLeadStatus;
  closed_reason: ClosedReason | null;
  closed_at: string | null;
  removed_reason: string | null;
  approved_at: string | null;
  touch_count: number;
  max_touches: number;
  next_touch_at: string | null;
  last_sent_at: string | null;
  replied_at: string | null;
  reply_intent: Intent | null;
  needs_reply: boolean;
  snoozed_until: string | null;
  converted_deal_id: number | null;
  company_id: number | null;
  contact_id: number | null;
  brochures: string[] | null;
  last_activity_at: string;
};

export type PreLeadMessage = {
  id: number;
  pre_lead_id: number;
  direction: "out" | "in";
  touch: number | null;
  status: "draft" | "queued" | "sent" | "failed" | "received";
  mailbox: string | null;
  from_email: string | null;
  from_name: string | null;
  to_email: string | null;
  subject: string | null;
  body: string | null;
  quoted: string | null;
  attached: string[] | null;
  linked: string[] | null;
  graph_id: string | null;
  internet_message_id: string | null;
  conversation_id: string | null;
  in_reply_to: string | null;
  scheduled_for: string | null;
  sent_at: string | null;
  received_at: string | null;
  error: string | null;
  intent: Intent | null;
  intent_quote: string | null;
  intent_by: string | null;
  is_bounce: boolean;
  /** who wrote the unsent draft, and the prompt when a model did (ThnkOS rewrites model drafts with Claude) */
  draft_by: "gpt-oss" | "llama" | "claude" | "user" | null;
  draft_prompt: string | null;
  created_at: string;
};
